/**
 * @file        src/components/Chip.jsx
 * @description Status pill. <Chip tone="ok|warn|pend|rej">…</Chip>
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
export default function Chip({ tone = 'ok', children }) {
  return <span className={`chip ${tone}`}>{children}</span>;
}
